import { CommonModule, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeNl from '@angular/common/locales/nl';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { DailyTotalsDetailsPageModule } from '../pages/daily-totals-details/daily-totals-details.module';
import { DailyTotalsOverviewPageModule } from '../pages/daily-totals-overview/daily-totals-overview.module';
import { HomePage } from '../pages/home/home';
import { NotificationsPageModule } from '../pages/notifications/notifications.module';
import { PlanningCreatePageModule } from '../pages/planning-create/planning-create.module';
import { PlanningDetailsPageModule } from '../pages/planning-details/planning-details.module';
import { PlanningPageOverviewModule } from '../pages/planning-overview/planning-overview.module';
import { ProfilePageModule } from '../pages/profile/profile.module';
import { SwipesPageModule } from '../pages/swipes/swipes.module';
import { TabsPageModule } from '../pages/tabs/tabs.module';
import { WeekStatusPageModule } from '../pages/week-status/week-status.module';
import { Auth0Provider } from '../providers/auth0.provider';
import { TimeTrackerBaseApi } from '../providers/generic.service';
import { PlanningService } from '../providers/planning.service';
import { SwipeService } from '../providers/swipe.service';
import { UserService } from '../providers/user.service';
import { MyApp } from './app.component';
import { IonicStorageModule } from '@ionic/storage';

// the second parameter 'fr' is optional
registerLocaleData( localeNl, 'nl-NL' );

@NgModule({
  declarations: [
    MyApp,
    HomePage,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    DailyTotalsOverviewPageModule,
    DailyTotalsDetailsPageModule,
    TabsPageModule,
    ProfilePageModule,
    NotificationsPageModule,
    FlexLayoutModule,
    PlanningPageOverviewModule,
    PlanningCreatePageModule,
    PlanningDetailsPageModule,
    WeekStatusPageModule,
    SwipesPageModule,
    IonicModule.forRoot(MyApp),
    BrowserAnimationsModule,
    MatIconModule,
    MatSortModule,
    MatButtonModule,
    HttpClientModule,
    IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    UserService,
    SwipeService,
    PlanningService,
    Auth0Provider,
    TimeTrackerBaseApi,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    { provide: LOCALE_ID, useValue: 'nl-NL' }
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts